import React from 'react';

import { Grid } from '@material-ui/core';
import { map } from 'lodash';

import { getWorkName } from 'pages/Teachers/shared/utils';
import { colors } from 'theme/palette';
import { formatDate } from 'utils/date';

import Button from 'components/Button';
import Typography from 'components/Typography';

import styles from './styles.module.scss';

const StudentWorkVersions = ({ activeTask, activeWork, setActiveWork }) => (
  <Grid container alignItems="center" className={styles.workGrid}>
    <Grid item>
      <Typography variant="B-Text-2" color={colors.grey1}>
        {formatDate({ date: activeWork.created_at, format: 'ddd M/DD h:mm A' })}
      </Typography>
    </Grid>
    <Grid container item xs justifyContent="flex-end" alignItems="center">
      {activeTask &&
        map(activeTask.work, (workItem, index) => (
          <Button
            key={index}
            noTypography
            variant="small"
            color="transparent"
            onClick={() => {
              setActiveWork(workItem);
            }}
          >
            <Typography
              variant="H-TEXT-3"
              color={
                activeWork.id === workItem.id ? colors.pink1 : colors.grey2
              }
            >
              {getWorkName(workItem)}
            </Typography>
          </Button>
        ))}
    </Grid>
  </Grid>
);

export default StudentWorkVersions;
